import inputKey from './inputKey'
const asyncInputKey = new Set(
  [inputKey.play,inputKey.playQQMusic,inputKey.playMv,inputKey.playQQMusicMv]
)
export default asyncInputKey



// WEBPACK FOOTER //
// ./src/cnConst/asyncInputKey.js